import {
	HttpClient,
	HttpContext,
	HttpHeaders,
	HttpParams
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

export type HttpVerb = 'get' | 'post';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	private readonly apiUrl: string;

	constructor(
		private http: HttpClient,
		@Inject('BASE_URL') baseUrl: string
	) {
		this.apiUrl = `${baseUrl}/api`;
	}

	get<T = any>(endPoint: string): Observable<T>;
	get<T = any>(
		endPoint: string,
		options: { params: HttpParams }
	): Observable<T>;
	get<T = any>(
		endPoint: string,
		options: { headers: HttpHeaders }
	): Observable<T>;
	get(endPoint: string, options?: any): Observable<any> {
		return this.http.get(`${this.apiUrl}/${endPoint}`, options);
	}
	post<T = any>(
		endPoint: string,
		body?: any,
		options?: { observe?: 'body'; responseType?: 'json'; context?: HttpContext }
	): Observable<T>;
	post(endPoint: string, body: any, options?: any): Observable<any> {
		return this.http.post(`${this.apiUrl}/${endPoint}`, body, options);
	}

	patch<T = any>(
		endPoint: string,
		body: any,
		options?: { observe: 'body'; responseType?: 'json' }
	): Observable<T>;
	patch(endPoint: string, body: any, options?: any): Observable<any> {
		return this.http.patch(`${this.apiUrl}/${endPoint}`, body, options);
	}

	request<T = any>(
		method: HttpVerb,
		url: string,
		options?: {
			body?: any;
			headers?: HttpHeaders;
			params?: HttpParams;
			context?: HttpContext;
		}
	): Observable<T> {
		return this.http.request<T>(method, url, options);
	}
}
